import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import useMediaQuery from "@mui/material/useMediaQuery";

const ImageSwipper = ({ galleryImages }) => {
  const matches = useMediaQuery("(min-width:600px)");


  return (
    <ImageGallery
      items={galleryImages}
      //   items={productDetails?.galleryImages}
      thumbnailPosition={matches ? "left" : "bottom"}
      showFullscreenButton={false}
      showPlayButton={false}
      showNav={false}
    />
  );
};

export default ImageSwipper;
